import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import PinForm from '../../../components/forms/PinForm';
import { useCreatePin } from '../../../hooks/usePinApi';
import { useNavigate } from 'react-router-dom';
import { PinDTO } from '../../../services/apiClient';

const PinCreate: React.FC = () => {
  const createPin = useCreatePin();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Pins', href: '/admin/pins' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: PinDTO) => {
    try {
      await createPin.mutateAsync(data);
      navigate('/admin/pins');
    } catch (error) {
      console.error('Error creating Pin:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/pins"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Pin.Edit'
    >
      <PinForm
        initialValues={{} as PinDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/pins')}
      />
    </AdminLayout>
  );
};

export default PinCreate;
